import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=1e828f0e"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports